const {
    forEach
} = require("underscore");

// $(document).ready(function () {
window.ScrollTopTo = function (element) {
    $('html, body').animate({
        scrollTop: $(element).offset().top - 40
    }, 300);
}


window.changeCarImg = function (path) {
    $(selectedCarImage).fadeOut('fast', function () {
        $(selectedCarImage).attr('src', path);
        $(selectedCarImage).fadeIn('fast');
    });


}
var model;
var carModal;
var carModalColor;
var carImage;
var details;
var selectedCarImage = $('.selectedCarImage')




function autoCheckedModel(inputModel) {
    $('.carSelectInputs').each((index, carSelectInput) => {
        if ($(carSelectInput).val() === inputModel) {
            $(carSelectInput).trigger("click");
        }
    })

}






// $(".carSelectInputs").val();

// select car First
$(".carSelectInputs").on("change", function () {
    $(".selectColor").hide().removeClass('active');
    $(".carModalInfoWrap").hide().removeClass('active');

    $(".carModalinputs").prop('checked', false);
    $(".carModalColorinputs").prop('checked', false);
    //$('.selectedCarImage').attr('src', themeURL + 'assets/images/skeletonCar.png');
    window.changeCarImg(themeURL + '/images/skeletonCar.png')


    // var inputValue = $(this).val();
    // var target = $("#" + inputValue);

    var inputValue = $(this).data('prop');
    var target = $("#" + inputValue);

    // if no Modals in This car Show colors
    if ($(target).find('.carModal-container').length == 1) {
      
        $(target).find('.carModalinputs').prop('checked', true)
        // var carModalInputsValue = $(target).find('.carModalinputs').val();
        var carModalInputsValue = $(target).find('.carModalinputs').data('prop');


        var carModalColorinputs = $("#" + carModalInputsValue);
        $(".colorInfoWrap").not(carModalColorinputs).hide();
        $(carModalColorinputs).show();
        details = $(target).find('.details').html();
        $(".selectColor").show();
        window.ScrollTopTo($(".selectColor"))
        setTimeout(function () {
            $(".selectColor").addClass('active');
        }, 250)



        // checkButton();
        // else if  Modals in This car Show Modals  to Choose

    } else {
        $(".carModalInfoWrap").not(target).hide().removeClass('active');
        $(".selectColor").hide().removeClass('active');

        $(target).show();
        setTimeout(function () {
            $(target).addClass('active');
        }, 150)
        window.ScrollTopTo($(target))



    }

    checkButton();
});

if (typeof pageCarModel !== 'undefined') {

    autoCheckedModel(pageCarModel)
}



$(".carModalinputs").on("change", function () {
    // checkcolor to check if to show the color select or stop for its step
    let checkcolor = $(this).hasClass('stop-color-showing') || false;
    $(".carModalColorinputs").prop('checked', false);



    window.changeCarImg(themeURL + '/images/skeletonCar.png')



    // var inputValue = $(this).val();
    // var target = $("#" + inputValue);
    
    var inputValue = $(this).data('prop');
    var target = $("#" + inputValue);

    $(".selectColor").hide().removeClass('active');

    $(".colorInfoWrap").not(target).hide().removeClass('active');


    if (!checkcolor)
        $(".selectColor").show();


    $(target).show();
    if (!checkcolor)
        window.ScrollTopTo($(".selectColor"));


    setTimeout(function () {
        $(target).addClass('active');

        if (!checkcolor)
            $(".selectColor").addClass('active');

		
    }, 250)


    
    details = $(this).siblings('.carModal').children('.details').html();
    checkButton();
});



// for changing the colors
$(".carModalColorinputs").on("change", function () {
    var inputValue2 = $(this).attr("data-src");
    //$('.selectedCarImage').attr('src', inputValue2);
    window.changeCarImg(inputValue2)




    checkButton();
});

function checkButton() {
    model = $(".carSelectInputs:checked").val();
    carModal = $(".carModalinputs:checked").val();
    carModalColor = $(".carModalColorinputs:checked").val();
    carImage = $(".carModalColorinputs:checked").attr('data-src');



    if (model && carModal && carModalColor) {
        $(".nxt").removeClass("notAllowedButton");
    } else {
        if (!$(".nxt").hasClass("notAllowedButton")) {
            $(".nxt").addClass("notAllowedButton");
        }
    }
}


$('.nxt').on('click', function () {
    //$('.reservation a[href="#book"]').tab('show');
    //$('.reservation a[href="#select"]').addClass('active');
    let activeTab = $('.reservation.nav-tabs .active').parent().next('li').find('a');
    let activeContentTab = $(activeTab).attr('href');

    $(activeTab).trigger('click');
    $('.book .finalResult .details').html(details);
    window.ScrollTopTo($(".reservation.nav-tabs"));
    setTimeout(() => {

        $(activeContentTab).find('.hideForNeed').addClass('active');
    }, 250)




});

$('.back').on('click', function () {
    $('.reservation.nav-tabs .active').parent().prev('li').find('a').trigger('click');

    window.ScrollTopTo($(".reservation.nav-tabs"));

});


$('.reservation.nav-tabs [data-toggle="tab"]').on('shown.bs.tab', function (event) {
    if ($(event.target).parent().prev('li').length > 0) {
        $(event.target).parent().prev('li').find('a').addClass('selected')
    }
})

// });